

export class EnquiryReportFilterDto{
    enquiryNumber?:string;

 
    
    constructor( enquiryNumber?:string ){
        this.enquiryNumber = enquiryNumber;
     

    }
}
